export const GET_REPORT_OPTIONS = 'GET_REPORT_OPTIONS';
export const GET_REPORT_OPTIONS_SUCCESS = 'GET_REPORT_OPTIONS_SUCCESS';
export const GET_REPORT_OPTIONS_FAILED = 'GET_REPORT_OPTIONS_FAILED';
export const GET_REPORT = 'GET_REPORT';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAILED = 'GET_REPORT_FAILED';
